import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataMenuItems } from '../models/DataMenuItems';
import { MenuItem } from '../models/MenuItem';
import { CONSTANTES } from '../shared/global';

@Injectable({
  providedIn: 'root'
})
export class MenuItemService {

  public url: string;

  constructor(private http: HttpClient) {
    this.url = CONSTANTES.api_url + "/menus";
  }

  getMenuItemsByUser(nid: string, role:string){
    const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
   
    let data = {
      nid: nid,
      role: role
    }

    return this.http.post<DataMenuItems>(this.url + "/menu", JSON.stringify(data), { headers: iheaders });
  }
}
